export default __webpack_public_path__ + "img/fa2790ea5c856f1b03d29ba5c8e23af5.svg";